import { useState } from 'react'
import { DeleteModal } from '../../../../components/common'
import { useFamily } from '../../../../hooks'
import { getError } from '../../../../utils'
import { showToast } from '../../../../utils/toast'

type Props = {
  onClose: () => void
  id?: string
}

const DeleteFamily = ({ onClose, id }: Props) => {
  const { deleteFamily } = useFamily()
  const [loading, setLoading] = useState(false)
  const handleFamilyDelete = async () => {
    setLoading(true)
    try {
      await deleteFamily({ id: id || '' })
      showToast('Family deleted successfully')
      onClose()
    } catch (err: any) {
      getError(err?.response?.data?.errors[0]?.detail)
    }
    setLoading(false)
  }
  return (
    <DeleteModal
      description="Confirm that you want to delete this Family history"
      handleSubmit={handleFamilyDelete}
      isLoading={loading}
      onClose={onClose}
      title="Delete Family History"
    />
  )
}

export default DeleteFamily
